import { render, staticRenderFns } from "./NumberedBadge.vue?vue&type=template&id=6cfc5a0e"
import script from "./NumberedBadge.vue?vue&type=script&lang=ts"
export * from "./NumberedBadge.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports